const env = import.meta.env as ImportMetaEnv

const inferDomainSpecificApiBase = (): string | undefined => {
  if (typeof window === 'undefined') {
    return undefined
  }

  const { protocol, hostname } = window.location
  const lowerHost = hostname.toLowerCase()

  if (lowerHost === 'localhost' || lowerHost === '127.0.0.1') {
    return `${protocol}//localhost:18080/api`
  }

  // Same-origin: backend is routed at wg-anzeigen.de/api (like kavithai.de) – no CORS
  const isWgAnzeigenHost = lowerHost === 'wg-anzeigen.de' || lowerHost === 'www.wg-anzeigen.de' || lowerHost.endsWith('.wg-anzeigen.de')
  const alreadyApiSubdomain = lowerHost.startsWith('api.')

  if (isWgAnzeigenHost && !alreadyApiSubdomain) {
    return '/api'
  }

  return undefined
}

const resolvedApiBase =
  env.VITE_WG_ANZEIGEN_API_URL ||
  env.VITE_API_BASE_URL ||
  inferDomainSpecificApiBase() ||
  '/api'

export const API_BASE_URL = resolvedApiBase

const DEFAULT_ASSETS_BASE_URL = 'https://s3.wg-anzeigen.de'

export const ASSETS_BASE_URL =
  env.VITE_WG_ANZEIGEN_ASSETS_URL ||
  env.VITE_ASSETS_BASE_URL ||
  env.VITE_S3_BASE_URL ||
  DEFAULT_ASSETS_BASE_URL
export const ADSENSE_CLIENT = import.meta.env.VITE_ADSENSE_CLIENT_ID || 'ca-pub-XXXXXXXXXXXXXXXX'
export const ADSENSE_TEST_MODE = String(import.meta.env.VITE_ADSENSE_TEST_MODE ?? 'true') !== 'false'
